import { useEffect } from 'react';

import { WORKSPACE_BASE } from '@/config/routes';

const FO_THEME_CLASS = 'theme-fo';

/**
 * 첫 렌더 전 톤 결정 — 라우트 지연 로드 동안의 전체 화면 로딩(RootLayout HydrateFallback)은 FO 레이아웃보다 먼저 그려져
 * Stillwater 로 번쩍인다. 첫 진입 경로가 워크스페이스가 아니면 미리 붙여 두고, 이후는 FO 레이아웃의 훅이 관리한다.
 */
export function applyInitialFoTheme(pathname: string) {
  if (!pathname.startsWith(WORKSPACE_BASE)) {
    document.documentElement.classList.add(FO_THEME_CLASS);
  }
}

/**
 * FO 톤(specs/049) 적용 — 마운트 동안 <html> 에 theme-fo 를 붙인다(theme-extensions.css).
 * 레이아웃 래퍼가 아니라 <html> 에 붙여야 body 포털(다이얼로그·토스트)까지 같은 톤이 된다.
 * 워크스페이스 레이아웃은 호출하지 않으므로 라우트 전환 시 Stillwater 로 돌아간다.
 */
export function useFoTheme() {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.add(FO_THEME_CLASS);
    return () => root.classList.remove(FO_THEME_CLASS);
  }, []);
}
